import { ACCOUNT_API_LOCK } from 'apiRoutes';
import useSubmit, { POST } from 'hooks/useSubmit';
import { FunctionComponent } from 'react';
import { MontelAccount } from 'domain/account/interfaces';
import { ConfirmationModal } from 'components/common/ConfirmationModal/ConfirmationModal';

interface BlockAccountModalProps {
	user: MontelAccount | undefined;
	onSuccess: (userId: string) => void;
	setModalOpen: (open: boolean) => void;
	isOpen: boolean;
}

export const BlockAccountModal: FunctionComponent<BlockAccountModalProps> = ({
	user,
	onSuccess,
	setModalOpen,
	isOpen,
}) => {
	if (!user) {
		return null;
	}

	const [blockPostData, blockStatus] = useSubmit(
		`${ACCOUNT_API_LOCK}`,
		POST,
		{
			messageOnError: 'An error occured, please try again!',
			messageOnSuccess: `User ${user.firstName} ${user.lastName} was rejected`,
			showApiError: true,
		},
	);
	const onReject = async (comment?: string) => {
		const result = await blockPostData({ accountId: user.id, comment });
		if (result.success) {
			onSuccess(user.id);
			setModalOpen(false);
		}
	};
	return (
		<ConfirmationModal
			showModal={isOpen}
			setShowModal={setModalOpen}
			onSubmit={onReject}
			header={'Lock Account'}
			text={`Are you sure you want to lock the account belonging to ${user.firstName} ${user.lastName}?`}
			buttonText={'Lock'}
			loadingStatus={blockStatus}
		/>
	);
};
